import React from "react";

export interface TacticLogoProps extends React.SVGProps<SVGSVGElement> {
  titleColor?: string;
  logoColor?: string;
}

export const TacticLogo: React.FC<TacticLogoProps> = ({
  titleColor,
  logoColor = "#00D579",
  ...props
}) => (
  <svg
    width="226"
    height="53"
    viewBox="0 0 226 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.162 16.4321C164.008 16.4321 162.262 14.686 162.262 12.5321V8.44603C162.262 8.05943 161.949 7.74603 161.562 7.74603H156.88C156.493 7.74603 156.18 8.05943 156.18 8.44603V35.645C156.18 41.1095 160.61 45.5393 166.075 45.5393H173.104C173.49 45.5393 173.804 45.2259 173.804 44.8393V40.158C173.804 39.7714 173.49 39.458 173.104 39.458C170.756 39.458 168.409 39.458 166.062 39.458C163.963 39.458 162.262 37.7566 162.262 35.658V23.2135C162.262 22.8269 162.576 22.5135 162.962 22.5135H173.104C173.49 22.5135 173.804 22.2001 173.804 21.8135V17.1321C173.804 16.7455 173.49 16.4321 173.104 16.4321H166.162Z"
      fill={titleColor || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.1621 16.4321C72.0082 16.4321 70.2621 14.686 70.2621 12.5321V8.44603C70.2621 8.05943 69.9487 7.74603 69.5621 7.74603H64.8801C64.4935 7.74603 64.1801 8.05943 64.1801 8.44603V35.645C64.1801 41.1095 68.6104 45.5393 74.0755 45.5393H81.1035C81.4902 45.5393 81.8036 45.2259 81.8036 44.8393V40.158C81.8036 39.7714 81.4902 39.458 81.1036 39.458C78.7564 39.458 76.4093 39.458 74.0621 39.458C71.9634 39.458 70.2621 37.7566 70.2621 35.658V23.2135C70.2621 22.8269 70.5755 22.5135 70.9621 22.5135H81.1035C81.4902 22.5135 81.8036 22.2001 81.8036 21.8135V17.1321C81.8036 16.7455 81.4902 16.4321 81.1036 16.4321H74.1621Z"
      fill={titleColor || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M186.282 8.44603C186.282 8.05943 185.968 7.74603 185.582 7.74603H180.9C180.513 7.74603 180.2 8.05943 180.2 8.44603V11.9464C180.2 12.333 180.513 12.6464 180.9 12.6464H185.582C185.968 12.6464 186.282 12.333 186.282 11.9464V8.44603ZM186.282 17.1461C186.282 16.7595 185.968 16.4461 185.582 16.4461H180.9C180.513 16.4461 180.2 16.7595 180.2 17.1461V44.8824C180.2 45.269 180.513 45.5824 180.9 45.5824H185.582C185.968 45.5824 186.282 45.269 186.282 44.8824V17.1461Z"
      fill={titleColor || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.23 16.4474C109.92 16.4474 109.635 16.6158 109.486 16.887L109.117 17.5554C108.926 17.9023 108.486 18.0202 108.138 17.8309C105.791 16.5537 103.214 15.8359 100.517 15.8359C91.9975 15.8359 85.098 22.6494 85.098 31.0456C85.098 39.4418 91.9975 46.2554 100.517 46.2554C103.217 46.2554 105.799 45.5364 108.149 44.2549C108.489 44.0692 108.92 44.1776 109.117 44.5116L109.475 45.1175C109.628 45.3763 109.906 45.5351 110.207 45.5351H115.237C115.623 45.5351 115.937 45.2217 115.937 44.8351V17.1474C115.937 16.7608 115.623 16.4474 115.237 16.4474H110.23ZM109.854 31.0456C109.854 36.0064 105.755 40.174 100.517 40.174C95.2792 40.174 91.1801 36.0064 91.1801 31.0456C91.1801 26.0849 95.2792 21.9173 100.517 21.9173C105.755 21.9173 109.854 26.0849 109.854 31.0456Z"
      fill={titleColor || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M145.049 35.4159C144.722 35.4159 144.425 35.5942 144.25 35.8691C142.614 38.4347 139.708 40.172 136.326 40.172C131.088 40.172 126.989 36.0044 126.989 31.0437C126.989 26.0829 131.088 21.9153 136.326 21.9153C139.679 21.9153 142.564 23.6225 144.207 26.1515C144.383 26.4224 144.678 26.5975 145.001 26.5975H150.126C150.598 26.5975 150.934 26.1404 150.766 25.6998C148.574 19.9376 142.937 15.8339 136.326 15.8339C127.806 15.8339 120.907 22.6474 120.907 31.0437C120.907 39.4399 127.806 46.2534 136.326 46.2534C142.966 46.2534 148.624 42.113 150.795 36.3104C150.96 35.8703 150.624 35.4159 150.154 35.4159H145.049Z"
      fill={titleColor || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M215.713 35.4159C215.387 35.4159 215.089 35.5942 214.914 35.8691C213.278 38.4347 210.372 40.172 206.99 40.172C201.752 40.172 197.653 36.0044 197.653 31.0437C197.653 26.0829 201.752 21.9153 206.99 21.9153C210.343 21.9153 213.228 23.6225 214.871 26.1515C215.047 26.4224 215.342 26.5975 215.665 26.5975H220.79C221.262 26.5975 221.598 26.1404 221.43 25.6998C219.238 19.9376 213.601 15.8339 206.99 15.8339C198.47 15.8339 191.571 22.6474 191.571 31.0437C191.571 39.4399 198.47 46.2534 206.99 46.2534C213.63 46.2534 219.288 42.113 221.46 36.3104C221.624 35.8703 221.288 35.4159 220.818 35.4159H215.713Z"
      fill={titleColor || "white"}
    />
    <path
      d="M225.16 18.3339H224.722V16.2333L224.036 18.3339H223.613L222.931 16.2411V18.3339H222.497V15.8419H223.23L223.827 17.7138L224.423 15.8342H225.16V18.3339Z"
      fill={titleColor || "white"}
    />
    <path
      d="M222.087 16.1985H221.324V18.3261H220.862V16.1985H220.103V15.8342H222.087V16.1985Z"
      fill={titleColor || "white"}
    />
    <path
      d="M4.97923 27.9511C3.84016 29.0902 1.99337 29.0902 0.854301 27.9511C-0.284767 26.812 -0.284767 24.9652 0.854301 23.8262C1.99337 22.6871 3.84016 22.6871 4.97923 23.8262C6.1183 24.9652 6.1183 26.812 4.97923 27.9511Z"
      fill={logoColor}
    />
    <path
      d="M17.5832 16.2638C16.3175 17.5294 14.2656 17.5294 12.9999 16.2638C11.7343 14.9982 11.7343 12.9462 12.9999 11.6806C14.2656 10.4149 16.3175 10.4149 17.5832 11.6806C18.8488 12.9462 18.8488 14.9982 17.5832 16.2638Z"
      fill={logoColor}
    />
    <path
      d="M29.0413 6.63897C27.5226 8.15773 25.0602 8.15773 23.5414 6.63897C22.0227 5.12022 22.0227 2.65782 23.5414 1.13907C25.0602 -0.379689 27.5226 -0.379689 29.0413 1.13907C30.5601 2.65782 30.5601 5.12022 29.0413 6.63897Z"
      fill={logoColor}
    />
    <path
      d="M51.0409 28.6386C49.5222 30.1574 47.0598 30.1574 45.541 28.6386C44.0223 27.1198 44.0223 24.6574 45.541 23.1387C47.0598 21.6199 49.5222 21.6199 51.0409 23.1387C52.5597 24.6574 52.5597 27.1198 51.0409 28.6386Z"
      fill={logoColor}
    />
    <path
      d="M28.3538 51.3257C27.2148 52.4648 25.368 52.4648 24.2289 51.3257C23.0898 50.1866 23.0898 48.3398 24.2289 47.2008C25.368 46.0617 27.2148 46.0617 28.3538 47.2008C29.4929 48.3398 29.4929 50.1866 28.3538 51.3257Z"
      fill={logoColor}
    />
    <path
      d="M16.6665 39.6384C15.5275 40.7775 13.6807 40.7775 12.5416 39.6384C11.4025 38.4993 11.4025 36.6525 12.5416 35.5135C13.6807 34.3744 15.5275 34.3744 16.6665 35.5135C17.8056 36.6525 17.8056 38.4993 16.6665 39.6384Z"
      fill={logoColor}
    />
    <path
      d="M40.4994 39.1801C39.2338 40.4457 37.1818 40.4457 35.9162 39.1801C34.6506 37.9144 34.6506 35.8625 35.9162 34.5968C37.1818 33.3312 39.2338 33.3312 40.4994 34.5968C41.7651 35.8625 41.7651 37.9144 40.4994 39.1801Z"
      fill={logoColor}
    />
    <path
      d="M40.0411 18.5554C38.2692 20.3273 35.3965 20.3273 33.6246 18.5554C31.8527 16.7836 31.8527 13.9108 33.6246 12.1389C35.3965 10.367 38.2692 10.367 40.0411 12.1389C41.813 13.9108 41.813 16.7836 40.0411 18.5554Z"
      fill={logoColor}
    />
    <path
      d="M29.0413 28.6386C27.5226 30.1574 25.0602 30.1574 23.5414 28.6386C22.0227 27.1198 22.0227 24.6574 23.5414 23.1387C25.0602 21.6199 27.5226 21.6199 29.0413 23.1387C30.5601 24.6574 30.5601 27.1198 29.0413 28.6386Z"
      fill={logoColor}
    />
  </svg>
);
